<template>
  <div class="progress-page">
    <!-- 第一组进度条 -->
    <div class="mars-progress-bar-component">
      <p>{{ $t('series.max_flow') }}</p>
      <div class="title" :style="{ color: progressGroups[0].titleColor }">
        {{ progressGroups[0].title }}
      </div>
      <div class="progress-container">
        <div class="progress-bg">
          <div
              class="progress-fill"
              :style="{
              width: progressGroups[0].progress + '%',
              backgroundColor: progressGroups[0].barColor
            }"
          ></div>
        </div>
        <div
            class="progress-text"
            :style="{ color: progressGroups[0].textColor }"
        >
          {{ progressGroups[0].customText }}
        </div>
      </div>
      <div class="description">{{ progressGroups[0].description }}</div>
    </div>
    <!-- 第二组进度条 -->
    <div class="mars-progress-bar-component">
      <div class="title" :style="{ color: progressGroups[1].titleColor }">
        {{ progressGroups[1].title }}
      </div>
      <div class="progress-container">
        <div class="progress-bg">
          <div
              class="progress-fill"
              :style="{
              width: progressGroups[1].progress + '%',
              backgroundColor: progressGroups[1].barColor
            }"
          ></div>
        </div>
        <div
            class="progress-text"
            :style="{ color: progressGroups[1].textColor }"
        >
          {{ progressGroups[1].customText }}
        </div>
      </div>
      <div class="description">{{ progressGroups[1].description }}</div>
    </div>
    <!-- 第三组进度条 -->
    <div class="mars-progress-bar-component">
      <p>{{ $t('series.max_vacuum') }}</p>
      <div class="title" :style="{ color: progressGroups[2].titleColor }">
        {{ progressGroups[2].title }}
      </div>
      <div class="progress-container">
        <div class="progress-bg">
          <div
              class="progress-fill"
              :style="{
              width: progressGroups[2].progress + '%',
              backgroundColor: progressGroups[2].barColor
            }"
          ></div>
        </div>
        <div
            class="progress-text"
            :style="{ color: progressGroups[2].textColor }"
        >
          {{ progressGroups[2].customText }}
        </div>
      </div>
      <div class="description">{{ progressGroups[2].description }}</div>
    </div>
    <div class="mars-progress-bar-component">
      <div class="title" :style="{ color: progressGroups[3].titleColor }">
        {{ progressGroups[3].title }}
      </div>
      <div class="progress-container">
        <div class="progress-bg">
          <div
              class="progress-fill"
              :style="{
              width: progressGroups[3].progress + '%',
              backgroundColor: progressGroups[3].barColor
            }"
          ></div>
        </div>
        <div
            class="progress-text"
            :style="{ color: progressGroups[3].textColor }"
        >
          {{ progressGroups[3].customText }}
        </div>
      </div>
      <div class="description">{{ progressGroups[3].description }}</div>
    </div>
    <div class="mars-progress-bar-component">
      <p>{{ $t('series.max_flow_vacuum') }}</p>
      <div class="title" :style="{ color: progressGroups[4].titleColor }">
        {{ progressGroups[4].title }}
      </div>
      <div class="progress-container">
        <div class="progress-bg">
          <div
              class="progress-fill"
              :style="{
              width: progressGroups[4].progress + '%',
              backgroundColor: progressGroups[4].barColor
            }"
          ></div>
        </div>
        <div
            class="progress-text"
            :style="{ color: progressGroups[4].textColor }"
        >
          {{ progressGroups[4].customText }}
        </div>
      </div>
      <div class="description">{{ progressGroups[4].description }}</div>
    </div>
    <div class="mars-progress-bar-component">
      <div class="title" :style="{ color: progressGroups[5].titleColor }">
        {{ progressGroups[5].title }}
      </div>
      <div class="progress-container">
        <div class="progress-bg">
          <div
              class="progress-fill"
              :style="{
              width: progressGroups[5].progress + '%',
              backgroundColor: progressGroups[5].barColor
            }"
          ></div>
        </div>
        <div
            class="progress-text"
            :style="{ color: progressGroups[5].textColor }"
        >
          {{ progressGroups[5].customText }}
        </div>
      </div>
      <div class="description">{{ progressGroups[5].description }}</div>
    </div>

    <div class="filter-galaxy">
      <div class="mars-question-text">{{ $t('series.clogged_filter') }}<br>
        {{ $t('series.try_me') }}
      </div>
      <div class="mars-solution-text"></div>
      <div class="mars-product-name">Galaxy Vortex45</div>
      <div class="mars-product-desc">
        {{ $t('series.vacuum_desc1') }}<br/>
        {{ $t('series.vacuum_desc2') }}
      </div>
      <div class="mars-product-feature">
        {{ $t('series.vacuum_desc3') }}<br/>
        {{ $t('series.vacuum_desc4') }}
      </div>
    </div>

<!--    <div class="filter-galaxy-image">-->
<!--      <img ref="filter-galaxy-image" src="../../static/series/cutbed/图片9.png" alt="Galaxy Vortex45产品图片"-->
<!--           class="product-image"/>-->
<!--    </div>-->

    <div class="progress-image">
      <img class="galaxy-image" ref="galaxy-image" src="../../static/series/cutbed/图片8.png" alt="设备展示图">
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProgressBarPage',
  data: function () {
    return {
      // 进度条数据组
      progressGroups: [
        {
          title: 'Galaxy Mars 55',
          titleColor: '#d86ecc',
          progress: 100,
          barColor: '#d86ecc',
          textColor: '#d86ecc',
          customText: '150%',
          description: ''
        },
        {
          title: this.$i18n.t('series.Competitor'),
          titleColor: '#000000',
          progress: 70,
          barColor: '#808080',
          textColor: '#000000',
          customText: '',
          description: ''
        },
        {
          title: 'Galaxy Mars 55',
          titleColor: '#4e95dd',
          progress: 80,
          barColor: '#4e95dd',
          textColor: '#4e95dd',
          customText: '120%',
          description: ''
        },
        {
          title: this.$i18n.t('series.Competitor'),
          titleColor: '#808080',
          progress: 60,
          barColor: '#808080',
          textColor: '#808080',
          customText: '',
          description: ''
        },
        {
          title: 'Galaxy Mars 55',
          titleColor: '#61cbf4',
          progress: 100,
          barColor: '#61cbf4',
          textColor: '#61cbf4',
          customText: '300%',
          description: ''
        },
        {
          title: this.$i18n.t('series.Competitor'),
          titleColor: '#808080',
          progress: 40,
          barColor: '#808080',
          textColor: '#808080',
          customText: '',
          description: ''
        }
      ],
      isMobile: false,
      timeline: null
    };
  },
  methods: {},
  mounted() {
    this.$nextTick(() => {
      this.$gsap.set('.mars-progress-bar-component', {
        // opacity: 0,
        y: 200
      })

      this.$gsap.set(this.$refs['filter-galaxy-image'], {
        y: 870,
        x: -150,
      })

      this.$gsap.set(this.$refs['galaxy-image'], {
        // opacity: 0,
      })

      // 进度条 class  progress-bg
      this.$gsap.set(['.mars-question-text',
        '.mars-solution-text',
        '.mars-product-name',
        '.mars-product-desc',
        '.mars-product-feature'
      ], {
        scale: 0.5,
        opacity: 0,
        transformOrigin: "0% 0%", // 左上角为中心点（x轴0%，y轴0%）
        y: 100
      })

      // 创建主时间线
      const masterTimeline = this.$gsap.timeline({
        scrollTrigger: {
          trigger: ['.mars-question-text',
            '.mars-solution-text',
            '.mars-product-name',
            '.mars-product-desc',
            '.mars-product-feature', '.mars-progress-bar-component', this.$refs['galaxy-image'], '.filter-galaxy-image', '.progress-bg'],
          start: 'top 150%',
          end: 'bottom 60%',
          markers: false,
          once: true,
          // scrub: 1,
          toggleActions: 'play none none none',
        }
      })

      // 进度条从下往上， 图片从右下出现
      masterTimeline
          .to('.mars-progress-bar-component', {
            y: -10,
            opacity: 1,
            duration: 2,
            ease: 'power2.in'
          }, 0)
      masterTimeline
          .to(['.filter-galaxy-image', this.$refs['galaxy-image']], {
            y: -250,
            x: -70,
            duration: 2,
            opacity: 1,
            ease: 'power2.in'
          }, 0)
      masterTimeline
          .from('.progress-bg', {
            duration: 2,
            ease: 'power2.in',
            scaleX: 0.1,
            transformOrigin: "0% 0%",
          }, 0)


      // 第二段文字进场
      masterTimeline
          .to('.mars-progress-bar-component', {
            // opacity: 0,
            duration: 2,
            y: -200,
            delay: 2,
            ease: 'power2.in'
          }, 0.5)
      masterTimeline
          .to(['.filter-galaxy-image', this.$refs['galaxy-image']], {
            y: -500,
            delay: 2,
            duration: 2,
            ease: 'power2.in'
          }, 0.5)

      masterTimeline
          .to(['.mars-question-text', '.mars-solution-text'], {
            y: -200,
            delay: 2,
            scaleY: 1,
            scaleX: 1,
            opacity: 1,
            duration: 2,
            ease: 'power2.in',
            transformOrigin: "0% 0%", // 左上角为中心点（x轴0%，y轴0%）
          }, 0.5)

      // 第三部分动画
      masterTimeline
          .to(['.filter-galaxy-image', this.$refs['galaxy-image']], {
            y: -550,
            delay: 2,
            duration: 1,
            ease: 'power2.in'
          }, 3)

      masterTimeline
          .to(['.mars-question-text', '.mars-solution-text'], {
            delay: 2,
            y: -250,
            duration: 1,
            color: "#808080",
            ease: 'power2.in',
            scale: 0.7,
            transformOrigin: "0% 0%", // 左上角为中心点（x轴0%，y轴0%）
          }, 3)

      masterTimeline.to(['.mars-product-name', '.mars-product-desc', '.mars-product-feature'], {
        y: -250,
        scaleY: 1.2,
        scaleX: 1.2,
        transformOrigin: "0% 0%", // 左上角为中心点（x轴0%，y轴0%）
        delay: 1.5,
        opacity: 1,
        duration: 1.5,
        ease: 'power2.in'
      }, 3)
    })
  }

};
</script>

<style scoped>
.progress-page {
  width: 85%;
  display: flex;
  flex-direction: column;
  position: relative;
  min-height: 900px; /* 使用min-height确保内容能完整显示 */
  margin: 100px auto 0; /* 居中显示 */
  padding-bottom: 50px; /* 底部留白 */
  margin-top: 300px;
}

.mars-progress-bar-component {
  width: 30%;
}

.title {
  font-size: 18px;
  font-weight: bold;
  text-align: left;
}

.progress-container {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
  gap: 10px;
}

.progress-bg {
  height: 10px;
  border-radius: 5px;
  flex: 1;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  border-radius: 5px;
  transition: width 0.5s ease;
}

.progress-text {
  font-size: 1.2em;
  font-weight: bold;
  min-width: 60px;
  text-align: right;
}

.description {
  font-size: 1em;
  color: #6b7280;
  text-align: left;
}

.progress-image {
  width: 50%;
  position: absolute;
  display: flex;
  justify-content: center;
  top: 80%;
  right: 0;
  transform: translateY(-50%); /* 垂直居中 */
}

.progress-image img {
  width: 90%;
  height: auto;
  object-fit: contain;
}

.progress-page p {
  margin-top: 20px;
  color: black;
  text-align: left;
  font-size: 1.5em;
}

.filter-galaxy {
  width: 59%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: left;
  margin-top: 100px;
}

.mars-question-text {
  font-size: 3em;
  margin-bottom: 10px;
}

.mars-solution-text {
  font-size: 3em;
  margin-bottom: 20px;
}

.mars-product-name {
  font-size: 1.5em;
  color: #db78cf;
  margin-bottom: 10px;
}

.mars-product-desc {
  font-size: 1em;
  margin-bottom: 10px;
}

.mars-product-feature {
  font-size: 1em;
}

/* 右侧图片部分样式 */
.filter-galaxy-image {
  width: 30%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: 80px;
  top: 50%;
}

.product-image {
  right: 123px;
  width: 100%;
  height: auto;
}


/* 手机端适配样式 */
@media (max-width: 767px) {
  .progress-page {
    width: 90%;
    margin-top: 50px;
    min-height: auto; /* 自动适应内容高度 */
    padding-bottom: 30px;
  }

  .mars-progress-bar-component {
    width: 100%; /* 手机端占满宽度 */
    margin-bottom: 25px;
  }

  .title {
    font-size: 16px;
  }

  .progress-container {
    gap: 8px;
  }

  .progress-bg {
    height: 8px; /* 进度条高度减小 */
  }

  .progress-text {
    font-size: 1em;
    min-width: 40px;
  }

  .description {
    font-size: 0.9em;
  }

  .progress-image {
    position: relative; /* 改为相对定位，放在进度条下方 */
    width: 100%;
    margin-top: 30px;
    top: 0;
    transform: none;
  }

  .progress-image img {
    width: 100%; /* 图片占满宽度 */
  }

  .progress-page p {
    margin-top: 30px;
    font-size: 1.3em;
    margin-bottom: 10px;
  }

  /* 第一组标题特殊处理 */
  .progress-page p:first-of-type {
    margin-top: 0;
  }
}
</style>

